(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    cartForm.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-cart-qty-minus]');
      var plus = e.target.closest('[data-cart-qty-plus]');
      if (!minus && !plus) return;

      var line = (minus || plus).getAttribute('data-line');
      var input = cartForm.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
      if (!input) return;

      var current = parseInt(input.value, 10) || 1;
      var newVal = minus ? Math.max(0, current - 1) : current + 1;
      input.value = newVal;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: newVal })
      }).then(function () {
        window.location.reload();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Sort select */
    var sortSelect = document.getElementById('collection-all-sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    /* Filter checkboxes */
    document.querySelectorAll('.collection-all__filter-checkbox').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var url = new URL(window.location.href);
        if (this.checked) {
          url.searchParams.append(this.name, this.value);
        } else {
          var keep = url.searchParams.getAll(this.name).filter(function (v) {
            return v !== this.value;
          }.bind(this));
          url.searchParams.delete(this.name);
          keep.forEach(function (v) {
            url.searchParams.append(this.name, v);
          }.bind(this));
        }
        window.location.href = url.toString();
      });
    });

    /* Toggle sidebar visibility */
    document.querySelectorAll('.collection-all__filter-toggle').forEach(function (btn) {
      var sidebar = document.getElementById('collection-all-sidebar');
      var layout = sidebar ? sidebar.closest('.collection-all__layout') : null;
      var textEl = btn.querySelector('.collection-all__filter-toggle-text');
      if (!sidebar || !textEl) return;

      btn.addEventListener('click', function () {
        var isHidden = sidebar.getAttribute('aria-hidden') === 'true';
        sidebar.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
        btn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        textEl.textContent = isHidden ? textEl.dataset.hide : textEl.dataset.show;
        if (layout) {
          layout.classList.toggle('collection-all__layout--no-sidebar', !isHidden);
        }
      });
    });

    /* Show more for filter values */
    document.querySelectorAll('.collection-all__show-more').forEach(function (btn) {
      var list = btn.closest('.collection-all__filter-list');
      if (!list) return;

      btn.addEventListener('click', function () {
        list.querySelectorAll('.collection-all__filter-item[hidden]').forEach(function (item) {
          item.removeAttribute('hidden');
        });
        btn.closest('li').style.display = 'none';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.featured-collection').forEach(function (section) {
      var track = section.querySelector('.featured-collection__track');
      var prevBtn = section.querySelector('.featured-collection__arrow--prev');
      var nextBtn = section.querySelector('.featured-collection__arrow--next');

      if (!track || !prevBtn || !nextBtn) return;

      function updateArrows() {
        var scrollLeft = Math.round(track.scrollLeft);
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = scrollLeft <= 0;
        nextBtn.disabled = scrollLeft >= maxScroll - 1;
      }

      function scrollBy(direction) {
        var card = track.querySelector('.featured-collection__product');
        if (!card) return;
        var distance = card.offsetWidth + parseInt(getComputedStyle(track).gap, 10) || 16;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      prevBtn.addEventListener('click', function () { scrollBy(-1); });
      nextBtn.addEventListener('click', function () { scrollBy(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });

      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('.header__menu-toggle');
    var mobileNav = document.getElementById('mobile-nav');
    if (!toggle || !mobileNav) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.classList.toggle('is-open');
      document.documentElement.style.overflow = expanded ? '' : 'hidden';
    });

    /* Close mobile nav on escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        toggle.setAttribute('aria-expanded', 'false');
        mobileNav.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
    });

    /* Close mega menus when clicking outside */
    document.addEventListener('click', function (e) {
      var megaMenus = document.querySelectorAll('[data-mega-menu]');
      megaMenus.forEach(function (menu) {
        if (!menu.contains(e.target)) {
          menu.removeAttribute('open');
        }
      });
    });

    /* Mega menu: open on hover, close on mouse leave */
    var megaMenus = document.querySelectorAll('[data-mega-menu]');
    megaMenus.forEach(function (menu) {
      var closeTimer;
      menu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        /* Close other open mega menus */
        megaMenus.forEach(function (other) {
          if (other !== menu) other.removeAttribute('open');
        });
        menu.setAttribute('open', '');
      });
      menu.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          menu.removeAttribute('open');
        }, 150);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var slider = document.querySelector('.hero-slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.hero-slider__slide');
    var dots = slider.querySelectorAll('.hero-slider__dot');
    var prevBtn = slider.querySelector('.hero-slider__arrow--prev');
    var nextBtn = slider.querySelector('.hero-slider__arrow--next');
    var current = 0;
    var total = slides.length;
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = (parseInt(slider.dataset.autoplaySpeed, 10) || 5) * 1000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('hero-slider__slide--active');
      if (dots.length) dots[current].classList.remove('hero-slider__dot--active');

      current = (index + total) % total;

      slides[current].classList.add('hero-slider__slide--active');
      if (dots.length) dots[current].classList.add('hero-slider__dot--active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (autoplay && total > 1) {
        timer = setInterval(next, speed);
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); next(); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(parseInt(dot.dataset.slideIndex, 10));
        startAutoplay();
      });
    });

    /* Pause on hover */
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    /* Keyboard navigation */
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { stopAutoplay(); prev(); startAutoplay(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); next(); startAutoplay(); }
    });

    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.pdp').forEach(function (pdp) {
      var form = pdp.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var variantIdInput = form.querySelector('[data-variant-id]');

      /* Read variant data injected as JSON */
      var variantsEl = pdp.querySelector('[data-product-variants]');
      var variants = [];
      if (variantsEl) {
        try {
          variants = JSON.parse(variantsEl.textContent);
        } catch (e) {}
      }

      /* Quantity buttons */
      pdp.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = pdp.querySelector('.pdp__qty-input');
          var delta = parseInt(this.getAttribute('data-qty-change'), 10);
          var val = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, val + delta);
        });
      });

      /* Find a variant that matches the selected options */
      function findVariant(selectedOptions) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (v.options[j] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }
          if (match) return v;
        }
        return null;
      }

      /* Variant option selection */
      pdp.querySelectorAll('.pdp__option-value input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          /* Update selected visual state */
          var group = this.closest('.pdp__option-group');
          group.querySelectorAll('.pdp__option-value').forEach(function (label) {
            label.classList.remove('pdp__option-value--selected');
          });
          this.closest('.pdp__option-value').classList.add('pdp__option-value--selected');

          /* Collect selected options */
          var selectedOptions = [];
          pdp.querySelectorAll('.pdp__option-group').forEach(function (g) {
            var checked = g.querySelector('input[type="radio"]:checked');
            if (checked) selectedOptions.push(checked.value);
          });

          /* Find matching variant and navigate with variant ID */
          var variant = findVariant(selectedOptions);
          if (variant) {
            variantIdInput.value = variant.id;
            window.location = window.location.pathname + '?variant=' + variant.id;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Toggle sidebar visibility */
    document.querySelectorAll('.collection-all__filter-toggle').forEach(function (btn) {
      var sidebar = document.getElementById('collection-all-sidebar');
      var layout = sidebar ? sidebar.closest('.collection-all__layout') : null;
      var textEl = btn.querySelector('.collection-all__filter-toggle-text');
      if (!sidebar || !textEl) return;

      btn.addEventListener('click', function () {
        var isHidden = sidebar.getAttribute('aria-hidden') === 'true';
        sidebar.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
        btn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        textEl.textContent = isHidden ? textEl.dataset.hide : textEl.dataset.show;
        if (layout) {
          layout.classList.toggle('collection-all__layout--no-sidebar', !isHidden);
        }
      });
    });

    /* Show more for filter values */
    document.querySelectorAll('.collection-all__show-more').forEach(function (btn) {
      var list = btn.closest('.collection-all__filter-list');
      if (!list) return;

      btn.addEventListener('click', function () {
        list.querySelectorAll('.collection-all__filter-item[hidden]').forEach(function (item) {
          item.removeAttribute('hidden');
        });
        btn.closest('li').style.display = 'none';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
